// NB hier alleen constanten die overal gebruikt worden.. de verschillen features/delen van de application state hebben hun eigen files met constanten

export const ENVIRONMENT_DEVARANA = 'dvr'; // zie TReservationFrontControllerConfig
export const ENVIRONMENT_DEN_ILP = 'di';
export const ENVIRONMENT_RIDDERRODE = 'rr';
export const ENVIRONMENT_SWEETLAKE = 'sl';

export const BOOKING_TYPE_SAUNA = 'BOOKING_TYPE_SAUNA';
export const BOOKING_TYPE_PACKAGEDEAL = 'BOOKING_TYPE_PACKAGEDEAL';

export const BUYABLE_TYPE_NON_PACKAGEDEAL = 'se'; // NB deze strings worden ook in html attributen en var namen gebruikt
export const BUYABLE_TYPE_PACKAGEDEAL = 'sa';

export const PAYMENT_TYPE_IDEAL = 'iDEAL';
export const PAYMENT_TYPE_CREDITCARD = 'creditcard';
export const PAYMENT_TYPE_BANCONTACT = 'bancontact';
export const PAYMENT_TYPE_MAESTRO = 'maestro';
export const PAYMENT_TYPE_APPLEPAY = 'applepay';
export const PAYMENT_TYPE_GOOGLEWALLET = 'google';
export const PAYMENT_TYPE_ONSITE = 'onsite';
export const PAYMENT_TYPE_ZERO = 'ZERO';
export const PAYMENT_TYPE_CADEAUBON = 'cadeaubon';
// NB Badenkaart is geen betaalmethode (meer). Dit is een wens op een ander entreeproduct - zie ENTRY_TYPE_OVERRULE_BADENKAART

export const PRESELECTION_TYPE_ENTRY = 'PRESELECTION_TYPE_ENTRY';
export const PRESELECTION_TYPE_TREATMENT = 'PRESELECTION_TYPE_TREATMENT';
export const PRESELECTION_TYPE_ACTION_ENTRY = 'PRESELECTION_TYPE_ACTION_ENTRY';
export const PRESELECTION_TYPE_ACTION_PACKAGE_DEAL = 'PRESELECTION_TYPE_ACTION_PACKAGE_DEAL';
export const PRESELECTION_TYPE_PACKAGE_DEAL = 'PRESELECTION_TYPE_PACKAGE_DEAL';
export const PRESELECTION_TYPE_TREATMENT_SUBCAT = 'PRESELECTION_TYPE_TREATMENT_SUBCAT';

export const ENTRY_TYPE_NORMAL = 'ENTRY_TYPE_NORMAL';
export const ENTRY_TYPE_OVERRULE_BADENKAART = 'ENTRY_TYPE_OVERRULE_BADENKAART';
export const ENTRY_TYPE_OVERRULE_BADENKAART_KORT = 'ENTRY_TYPE_OVERRULE_BADENKAART_KORT';

export const ENTRY_DURATION_DAY = 'dag';
export const ENTRY_DURATION_EVENING = 'avond';
export const ENTRY_DURATION_MORNING = 'ochtend';
export const ENTRY_DURATION_2_HOUR = '2uur';

export const TEST_SHORTCUT_TO_FORM = 'TEST_SHORTCUT_TO_FORM';
export const TEST_FILL_BOOKER = 'TEST_FILL_BOOKER';

export const UI_ID_PANEL10_RESTYPE = 'UI_ID_PANEL10_YOURSTAY';
export const UI_ID_PANEL14_RESSUBTYPE = 'UI_ID_PANEL14_RESSUBTYPE';
export const UI_ID_PANEL17_PEOPLE = 'UI_ID_PANEL17_PEOPLE';
export const UI_ID_PANEL20_CALENDAR = 'UI_ID_PANEL20_CALENDAR';
export const UI_ID_PANEL30_TIME = 'UI_ID_PANEL30_TIME';
export const UI_ID_PANEL40_PACKAGEDEAL = 'UI_ID_PANEL40_PACKAGEDEAL';
export const UI_ID_PANEL50_TREATMENTS = 'UI_ID_PANEL50_TREATMENTS';
export const UI_ID_PANEL60_FORM = 'UI_ID_PANEL60_FORM';
export const UI_ID_PANEL70_PAY = 'UI_ID_PANEL70_PAY';

// CARD
export const UI_CARD_CTA_ADD = 'UI_CARD_CTA_ADD';
export const UI_CARD_CTA_INFO = 'UI_CARD_CTA_INFO';
export const UI_CARD_CTA_REMOVE = 'UI_CARD_CTA_REMOVE';

// testcalls met hondjes
export const ACTION_API_CALL_SUCCESS = 'ACTION_API_CALL_SUCCESS';
export const ACTION_API_CALL_FAILURE = 'ACTION_API_CALL_FAILURE';
export const ACTION_API_CALL_REQUEST = 'ACTION_API_CALL_REQUEST';


export const CSS_BP_TABLET = '230px';